import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconCards } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface FlashcardSetListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const FlashcardSetListItem: React.FC<FlashcardSetListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconCards}
    typeLabel="Flashcards"
    testId="flashcard-set-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.STUDY }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img loading="lazy"
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default FlashcardSetListItem
